import React, { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LanguageIcon from '@mui/icons-material/Language';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { useParams, useSearchParams } from 'react-router-dom';
import { uniq, filter } from 'lodash';

import { useMailListMutation } from 'app/apis/mail.api';
import { useLazyPublishQuery, useLazyUnpublishQuery } from 'app/apis/instruments.api';

const SearchToolbar = (props) => {
  const {
    selected,
    instruments,
    hideNumber = false,
    enablePublishUnpublish = false,
    isPublish = false,
    getShareIds,
  } = props;
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [mailList, mailListResult] = useMailListMutation();
  const { lang } = useParams();
  const [count, setCount] = useState(0);
  const [publishTrigger, pr] = useLazyPublishQuery();
  const [unpublishTrigger, ur] = useLazyUnpublishQuery();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (instruments) {
      setCount(instruments.length)
    }
  }, [instruments])

  const shareList = async () => {
    let email = prompt(t("Email recipients"), "");
    if (email != null && email !== "") {
      let recipients = email.split(';').map(e => e.trim());
      let invalidRecipients = recipients.filter(e => !validateEmail(e));
      if (invalidRecipients.length === 0) {
        await shareListViaMail(recipients);
        enqueueSnackbar(t('emailsIncluded', { mails: recipients.filter(e => validateEmail(e)).join('; ') }), { variant: 'success' });

      } else {
        alert(t('emailValidationFailed') + " \n\n " + t('emailsExcluded', { mails: invalidRecipients.join('; ') }));
        enqueueSnackbar(t('emailValidationFailed') + " \n\n " + t('emailsExcluded', { mails: invalidRecipients.join('; ') }), { variant: 'error' });
      }
    }
  }

  const validateEmail = (email) => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const shareListViaMail = async (emails) => {
    const shareIds = uniq(filter(getShareIds(), x => !!x));
    let body = "ids=" + encodeURIComponent(shareIds.join('|'))
      + '&' + "to=" + encodeURIComponent(emails.join(';'))
      + '&' + "lang=" + encodeURIComponent(lang)
    await mailList(body);
  }

  const onPublish = async () => {
    m(publishTrigger);
  }

  const onUnpublish = async () => {
    m(unpublishTrigger);
  }

  const m = async (m) => {
    if (selected && selected.length > 0) {
      let res = await m({ id: selected.join(',') });
      if (res.status === "rejected" && res.error && res.error.status === 420) {
        enqueueSnackbar(res.error?.data?.errorCode, { variant: 'error' });
      } else {
        window.location.reload();
      }
    }
  }

  const handleTagDelete = (tag) => {
    const newSearchParams = {};
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      if (param === 'tags') {
        newSearchParams[param] = value.split(';').filter(e => e !== tag).join(';');
      } else {
        newSearchParams[param] = value;
      }
    }
    setSearchParams({ ...newSearchParams })
    window.location.reload();
  }

  if (count <= 0 && !searchParams.get('tags')) return null;

  return (
    <Stack direction={'row'} justifyContent={"space-between"}>
      <Stack direction={'row'} spacing={1}>
        {
          enablePublishUnpublish && (isPublish ?
            <FileOpenOutlinedIcon style={{ cursor: 'pointer' }} onClick={onUnpublish}/> :
            <LanguageIcon style={{ cursor: 'pointer' }} onClick={onPublish}/>)
        }
        <Button
          variant="contained"
          color="info"
          size="small"
          onClick={() => window.print()}
        >
          {t('downloadPrintListButton')}
        </Button>
        <Button variant="contained" color="info" size="small" onClick={shareList}>
          {t('shareListButton')}
        </Button>
      </Stack>
      {
        searchParams.get('mode') && searchParams.get('mode') === 'advanced'
        && searchParams.get('tags') && <Stack direction={'row'} spacing={1}>
          {
            searchParams.get('tags').split(';')
              .map((e, i) => <Chip key={i} label={e} variant="outlined" onDelete={() => handleTagDelete(e)}/>)
          }
        </Stack>
      }
      {!hideNumber && (
        <Box>
          <Typography variant="openSans14" fontWeight={"bold"}>
            {t('Number of legal instruments')}: {count}
          </Typography>
        </Box>
      )}
    </Stack>

  );
};

export default SearchToolbar;
